module.exports = __webpack_public_path__ + "images/emoji/first_quarter_moon_with_face.014021ee4cb764529ca9.png";